import React from 'react';
import './index.less';

class GradeDescription extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
        <div className="page_type_h5">
            <div id="GradeDescription">
                <h2>会员权益解读</h2>
                <section>
                    <h3>一、会员等级介绍</h3>
                    <p>会员等级是基于注册用户一定时期内使用绿色慧联业务累积获取的成长值来换取对应等级，当用户累计成长值达到相应的等级门槛即刻升级。用户可以通过租车、充电、支付租金等方式来获取成长值，从而提升等级。</p>
                </section>
                <section>
                    <h3>二、会员有效期</h3>
                    <p>会员等级有效期为1年(365天)</p>
                    <p>若用户升级，新等级有效期从升级当天开始计算。若您没有在当前有效期内升级，新等级有效期会在当前等级有效期到期日的次日重新计算并变更为新的等级。</p>
                </section>
                <section>
                    <h3>三、升降级规则</h3>
                    <p>完成注册的用户在等级有效期内成长值达到升级门槛值时，对应成长值将扣除，新等级立即生效。等级到期后,用户等级将根据当前的成长值重新计算。剩余成长值等于当前等级要求成长值的可维持当前等级，不足以维持当前等级的逐级往下，直到剩余成长值符合的级别为止，若剩余成长值不足100（白银级别要求成长值）则会员等级直接掉到青铜。</p>
                </section>
                <section>
                    <h3>四、成长值说明</h3>
                    <p>用来评定用户会员等级的值称为成长值; 租车、充电、支付租金等方式来获取成长值,从而提升会员等级。用户升级成长值会自动扣减。用户每日最多获取1000成长值，单月上限5000成长值，当获取成长值达到限制时,超过限额部分的成长值不再发放。请勿违规刷成长值(包括但不限于虚假交易、恶意退款等)，如发现存在违规行为，我们有权取消你获得成长值的资格。</p>
                </section>
                <section>
                    <h3>五、等级权益</h3>
                    <p>不同的会员可享受该等级专属权益。请您理解，等级权益提供方可能会根据运营等实际情况对权益进行动态调整,具体权益届时以页面展示为准。</p>
                </section>
                <section>
                    <h3>六、会员等级对照表</h3>
                    <p>用户成长值达到对应升级门槛,即立即升级。有效期结束后,用户的等级将根据上个有效期内已累计积分重新计算等级。</p>
                    <div className="table1">
                        <div className="table-view">
                            <div className="table-clumn">等级</div>
                            <div className="table-clumn">等级</div>
                            <div className="table-clumn">对应升级门槛（成长值）</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">L1</div>
                            <div className="table-clumn">青铜会员</div>
                            <div className="table-clumn">50</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">L2</div>
                            <div className="table-clumn">白银会员</div>
                            <div className="table-clumn">100</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">L3</div>
                            <div className="table-clumn">黄金会员</div>
                            <div className="table-clumn">2000</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">L4</div>
                            <div className="table-clumn">铂金会员</div>
                            <div className="table-clumn">4000</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">L5</div>
                            <div className="table-clumn">钻石会员</div>
                            <div className="table-clumn">8000</div>
                        </div>
                    </div>
                </section>
                <section>
                    <h3>七、成长值获取方式</h3>
                    <div className="table1">
                        <div className="table-view">
                            <div className="table-clumn">注册</div>
                            <div className="table-clumn">50/账号</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">充电消费</div>
                            <div className="table-clumn">1元/1点</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">充值电费</div>
                            <div className="table-clumn">充值10元/1点</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">租车</div>
                            <div className="table-clumn">1辆车/50点</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">自付租金</div>
                            <div className="table-clumn">20元/1点</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">邀请他人注册</div>
                            <div className="table-clumn">1人/50点</div>
                        </div>
                    </div>
                    <p>备注：</p>
                    <p><b>注册账号：</b>一个账号注册成功后即可获取；</p>
                    <p><b>充电消费：</b>充电每消费一元即可获取一点成长值；</p>
                    <p><b>充值电费：</b>仅限客户自己通过app充值、后台管理员转账和充值的电费（不含企业电卡分配的电费）；</p>
                    <p><b>租车：</b>新/转/续/权利义务转移业务租车算一辆，续租一次算增加一辆车，换租/替换车不计算成长值；</p>
                    <p><b>自付租金：</b>用户通过绿色慧联app每支付20元租金将获得1点成长值，不足20元无法获取；</p>
                    <p><b>邀请他人注册：</b>邀请他人成功注册绿色慧联app后即可获取50点成长值。</p>
                </section>
                <section>
                    <h3>八、会员权益</h3>
                    <div className="table1">
                        <div className="table-view">
                            <div className="table-clumn">会员权益</div>
                            <div className="table-clumn">青铜会员</div>
                            <div className="table-clumn">白银会员</div>
                            <div className="table-clumn">黄金会员</div>
                            <div className="table-clumn">铂金会员</div>
                            <div className="table-clumn">钻石会员</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">专属客服</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">免费查违章</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                            <div className="table-clumn">√</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">服务费折扣</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">95折</div>
                            <div className="table-clumn">9折</div>
                            <div className="table-clumn">85折</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">免费救援</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">1次/年</div>
                            <div className="table-clumn">1次/年</div>
                            <div className="table-clumn">2次/年</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">上门送/收车</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">1次/年</div>
                            <div className="table-clumn">1次/年</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">上门维修</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">1次/年</div>
                            <div className="table-clumn">1次/年</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">免费充电</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">1次/年</div>
                        </div>
                        <div className="table-view">
                            <div className="table-clumn">免费试用</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">--</div>
                            <div className="table-clumn">1次/年</div>
                        </div>
                    </div>
                    <p>备注：</p>
                    <p><b>专属客服：</b>享受优先接入线上客服；</p>
                    <p><b>免费查违章：</b>租慧联车辆用户享受免费查违章服务；</p>
                    <p><b>服务费折扣：</b>充电费中的服务费折扣，若充电站有活动价，折扣以最低的为准；</p>
                    <p><b>免费救援：</b>租赁慧联车辆的客户出事故时享受免费前往救援；限制服务范围30公里，超出里程按照慧联标准价格收费（桥隧封闭道路除外）；</p>
                    <p><b>上门送/收车：</b>租赁慧联车辆客户享受上门送车服务，限制服务范围30公里，超出按照慧联标准价格收费；</p>
                    <p><b>上门维修：</b>租赁慧联车辆客户享受上门送钥匙、搭电、更换轮胎；限制服务范围30公里，超出按照慧联标准价格收费；</p>
                    <p><b>免费充电：</b>享受免费充电一次；</p>
                    <p><b>免费试用：</b>享受每年1次，每次最多7天的免费试用车服务；</p>
                </section>
            </div>
        </div>
    );
  }
}

export default GradeDescription;



// WEBPACK FOOTER //
// ./src/staticPage/gradeDescription/index.js